module.exports = __webpack_public_path__ + "static/img/20.62be9fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/20.png
// module id = JOR0
// module chunks = 0